import Fetch from './fetch';

const AcademySegmentsApi = {
  create: (data, academyId) => Fetch.post(`academies/${academyId}/segments`, data),
  delete: (segmentId) => Fetch.delete(`academy_segments/${segmentId}`),
  fetchObjectSegments: (academyId, objectId, objectType) =>
    Fetch.get(`academy_segments/${academyId}/object/${objectId}/${objectType}`),
  fetchUsersForFilters: (academyId, filterData) =>
    // post request due to potential URI length: https://stackoverflow.com/a/23379184/7377039
    Fetch.post(`academy_segments/${academyId}/users_for_temp_filters`, {
      visibility_params: JSON.stringify(filterData),
    }),
  update: (data, segmentId) => Fetch.put(`academy_segments/${segmentId}`, data),
  updateObjectSegments: (academyId, data) => Fetch.post(`academy_segments/${academyId}/object`, data),
};
export default AcademySegmentsApi;
